import axios from 'axios';

const getValorMoeda = moeda => axios.get(`/valores-moedas/${moeda}`);

export default {
  getValorMoeda,
};
